function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { setHashString, getHashString } from "@macrostrat/ui-components";
import { MapBackend, MapLayer } from "./core";
import { FilterType } from "../handlers/filters";
import { formatCoordForZoomLevel, fmtInt, fmt1, fmt2 } from "~/map-interface/utils/formatting";
export function hashStringReducer(state, action) {
  switch (action.type) {
    case "set-map-backend":
    case "add-filter":
    case "remove-filter":
    case "clear-filters":
    case "toggle-map-layer":
    case "map-moved":
      updateURI(state.core);
  }

  return state;
}
// function getFilterDescriptor(filter: Filter): string {
//   if (filter.type.includes("lithology"))
//   return filter.id ?? filter.name;
// }
export function updateURI(state) {
  var _state$filters;

  var args = {}; // Get filter information from URI.

  var _iterator = _createForOfIteratorHelper((_state$filters = state.filters) !== null && _state$filters !== void 0 ? _state$filters : []),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _args, _filter$type, _args$_filter$type, _filter$id;

      var filter = _step.value;
      (_args$_filter$type = (_args = args)[_filter$type = filter.type]) !== null && _args$_filter$type !== void 0 ? _args$_filter$type : _args[_filter$type] = [];
      args[filter.type].push((_filter$id = filter.id) !== null && _filter$id !== void 0 ? _filter$id : filter.name);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  applyXYPosition(args, state);
  applyHeightAndOrientation(args, state);
  var layers = getLayerDescriptionFromLayers(state.mapLayers);
  args = _objectSpread(_objectSpread({}, args), layers);
  setHashString(args, {
    arrayFormat: "comma",
    sort: false
  });
  return state;
}

function applyXYPosition(args, state) {
  var _state$mapPosition$ta;

  var pos = state.mapPosition.camera;
  if (pos == null) return;
  var zoom = (_state$mapPosition$ta = state.mapPosition.target) === null || _state$mapPosition$ta === void 0 ? void 0 : _state$mapPosition$ta.zoom;
  var x = formatCoordForZoomLevel(pos.lng, zoom);
  var y = formatCoordForZoomLevel(pos.lat, zoom);
  var infoMarkerPosition = state.infoMarkerPosition;

  if (infoMarkerPosition != null) {
    /* If the info marker is at the same position as the map, there
     * is no need to include it in the hash string. This should lead
     * to shorter sharable URLs */
    var infoX = formatCoordForZoomLevel(infoMarkerPosition.lng, zoom);
    var infoY = formatCoordForZoomLevel(infoMarkerPosition.lat, zoom);

    if (infoX == x || infoY == y) {
      return;
    }
  }

  args["x"] = x;
  args["y"] = y;
}

function applyHeightAndOrientation(args, state) {
  var _state$mapPosition$ca, _state$mapPosition$ta2;

  var pos = (_state$mapPosition$ca = state.mapPosition.camera) !== null && _state$mapPosition$ca !== void 0 ? _state$mapPosition$ca : {
    bearing: 0,
    pitch: 0,
    altitude: null
  };
  var zoom = (_state$mapPosition$ta2 = state.mapPosition.target) === null || _state$mapPosition$ta2 === void 0 ? void 0 : _state$mapPosition$ta2.zoom;

  if (pos.bearing == 0 && pos.pitch == 0 && zoom != null) {
    args.z = fmt1(zoom);
  } else if (pos.altitude != null) {
    if (pos.altitude > 5000) {
      args.z = fmt2(pos.altitude / 1000) + "km";
    } else {
      args.z = fmtInt(pos.altitude) + "m";
    }
  }

  if (pos.bearing != 0) {
    var az = pos.bearing;
    if (az < 0) az += 360;
    args.a = fmtInt(az);
  }

  if (pos.pitch != 0) {
    args.e = fmtInt(pos.pitch);
  }
}

function _fmt(x) {
  if (Array.isArray(x)) {
    x = x[0];
  }

  return parseFloat(x.toString());
}

export function getInitialStateFromHash(state, hashString) {
  var newState = updateMapPositionForHash(state, hashString);
  var filters = getActiveFiltersFromHash(hashString);
  return [newState, filters];
}

function getLayerDescriptionFromLayers(layers) {
  // Remove layers that should be managed by the 'hide' flag
  var layerArr = Array.from(layers).filter(function (lyr) {
    return lyr != "labels";
  });

  if (layerArr.length == 0) {
    // Special case for no layers
    layerArr.push("none");
  } // If all geology layers are present, remove them and replace with "geology"


  var geoLayers = layerArr.filter(function (lyr) {
    return geologyLayers.includes(lyr);
  });

  if (geoLayers.length == geologyLayers.length) {
    layerArr = layerArr.filter(function (lyr) {
      return !geologyLayers.includes(lyr);
    });
    layerArr.push("geology");
  } // If "geology" + "labels" are the only layers, we remove them as implicit


  if (layerArr.length == 1 && layerArr.includes("geology")) {
    layerArr = [];
  }

  var desc = {};

  if (layerArr.length > 0) {
    desc.show = layerArr;
  }

  if (!layers.has(MapLayer.LABELS)) {
    desc.hide = ["labels"];
  }

  return desc;
}

function isValidLayer(test) {
  var vals = Object.values(MapLayer);
  return vals.includes(test);
}

function validateLayers(layers) {
  return new Set(layers.filter(isValidLayer));
}

var geologyLayers = ["bedrock", "lines"];

function layerDescriptionToLayers(layers, hiddenLayers) {
  if (!Array.isArray(layers)) {
    layers = [layers];
  }

  if (layers.length == 0) {
    // Add implicit layers
    layers = ["geology"];
  }

  if (layers.includes("geology")) {
    var _layers;

    layers = layers.filter(function (lyr) {
      return lyr != "geology";
    });

    (_layers = layers).push.apply(_layers, geologyLayers);
  }

  if (layers.length == 1 && layers[0] == "none") {
    layers = [];
  }

  if (hiddenLayers != null) {
    if (!Array.isArray(hiddenLayers)) {
      hiddenLayers = [hiddenLayers];
    }

    if (!hiddenLayers.includes("labels")) {
      layers.push(MapLayer.LABELS);
    }
  }

  return validateLayers(layers);
}

export function updateMapPositionForHash(state, hashString) {
  // Get the default map state
  try {
    var _getHashString, _state$infoMarkerPosi, _state$infoMarkerPosi2, _state$infoMarkerPosi3, _state$infoMarkerPosi4;

    var hashData = (_getHashString = getHashString(hashString)) !== null && _getHashString !== void 0 ? _getHashString : {};
    var _hashData$show = hashData.show,
        show = _hashData$show === void 0 ? [] : _hashData$show,
        _hashData$hide = hashData.hide,
        hide = _hashData$hide === void 0 ? [] : _hashData$hide; // Set default view parameters

    var _hashData$x = hashData.x,
        x = _hashData$x === void 0 ? (_state$infoMarkerPosi = (_state$infoMarkerPosi2 = state.infoMarkerPosition) === null || _state$infoMarkerPosi2 === void 0 ? void 0 : _state$infoMarkerPosi2.lng) !== null && _state$infoMarkerPosi !== void 0 ? _state$infoMarkerPosi : 16 : _hashData$x,
        _hashData$y = hashData.y,
        y = _hashData$y === void 0 ? (_state$infoMarkerPosi3 = (_state$infoMarkerPosi4 = state.infoMarkerPosition) === null || _state$infoMarkerPosi4 === void 0 ? void 0 : _state$infoMarkerPosi4.lat) !== null && _state$infoMarkerPosi3 !== void 0 ? _state$infoMarkerPosi3 : 23 : _hashData$y,
        _hashData$z = hashData.z,
        z = _hashData$z === void 0 ? state.infoMarkerPosition != null ? 7 : 2 : _hashData$z,
        _hashData$a = hashData.a,
        a = _hashData$a === void 0 ? 0 : _hashData$a,
        _hashData$e = hashData.e,
        e = _hashData$e === void 0 ? 0 : _hashData$e;
    var mapLayers = layerDescriptionToLayers(show, hide);

    var lng = _fmt(x);

    var lat = _fmt(y);

    var altitude = null;
    var zoom = null;

    var _z = z.toString();

    if (_z.endsWith("km")) {
      altitude = _fmt(_z.substring(0, _z.length - 2)) * 1000;
    } else if (_z.endsWith("m")) {
      altitude = _fmt(_z.substring(0, _z.length - 1));
    } else {
      zoom = _fmt(z);
    }

    var bearing = _fmt(a);

    var pitch = _fmt(e);

    var target = undefined;

    if (bearing == 0 && pitch == 0 && zoom != null) {
      target = {
        lat: lat,
        lng: lng,
        zoom: zoom
      };
    }

    var position = {
      camera: {
        lng: _fmt(x),
        lat: _fmt(y),
        altitude: altitude,
        bearing: _fmt(a),
        pitch: _fmt(e)
      },
      target: target
    };
    return _objectSpread(_objectSpread({}, state), {}, {
      mapPosition: position,
      mapLayers: mapLayers,
      mapBackend: MapBackend.MAPBOX3
    });
  } catch (e) {
    console.error("Invalid map state:", e);
    return state;
  }
}

function formatID(id, type) {
  switch (type) {
    case FilterType.AllLithologyClasses:
    case FilterType.AllLithologyTypes:
    case FilterType.LithologyClasses:
    case FilterType.LithologyTypes:
      return id;

    default:
      return Number(id);
  }
}

function getActiveFiltersFromHash(hashString) {
  var _getHashString2;

  var hashData = (_getHashString2 = getHashString(hashString)) !== null && _getHashString2 !== void 0 ? _getHashString2 : {};
  var filters = [];

  for (var _i = 0, _Object$values = Object.values(FilterType); _i < _Object$values.length; _i++) {
    var type = _Object$values[_i];
    var val = hashData[type];

    if (val != null) {
      var _iterator2 = _createForOfIteratorHelper(Array.isArray(val) ? val : [val]),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var v = _step2.value;
          filters.push({
            type: type,
            id: formatID(v, type)
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }

  return filters;
}